import React from "react";
import { CiMenuFries } from "react-icons/ci";
import MyButton from "../../common/Button/MyButton";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/customer/components/MyNavbar.css";

const MyNavbar = ({ onMenuClick }) => {
  const Navigate = useNavigate();
  return (
    <nav className="custom-navbar">
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* Logo Section - Col for responsive */}
          <div className="col-6 col-md-3">
            <div className="navbar-logo">
              <div className="logo-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <rect
                    width="32"
                    height="32"
                    rx="8"
                    fill="var(--secondary-color)"
                  />
                  <path
                    d="M16 8C13.5 8 11.5 10 11.5 12.5V20C11.5 22.5 13.5 24.5 16 24.5C18.5 24.5 20.5 22.5 20.5 20V12.5C20.5 10 18.5 8 16 8Z"
                    fill="white"
                  />
                  <ellipse
                    cx="16"
                    cy="12"
                    rx="2.5"
                    ry="3"
                    fill="var(--secondary-color)"
                  />
                </svg>
              </div>
              <span
                className="logo-text"
                onClick={() => {
                  Navigate("/");
                }}
              >
                MilkyWay
              </span>
            </div>
          </div>

          {/* Desktop Menu - Hidden on mobile */}
          <div className="col-md-6 d-none d-md-block">
            <div className="navbar-menu">
              <a
                href="/pricing"
                className="nav-link"
                onClick={() => {
                  Navigate("/pricing");
                }}
              >
                Pricing
              </a>
              <a
                href="/distributors"
                className="nav-link"
                onClick={() => {
                  Navigate("/distributors");
                }}
              >
                Distributors
              </a>

              <a
                href="/about"
                className="nav-link"
                onClick={() => {
                  Navigate("/about");
                }}
              >
                About
              </a>
              <a
                href="/contact"
                className="nav-link"
                onClick={() => {
                  Navigate("/contact");
                }}
              >
                Contact
              </a>
              <a
                href="/blogs"
                className="nav-link"
                onClick={() => {
                  Navigate("/blogs");
                }}
              >
                Blogs
              </a>
            </div>
          </div>

          {/* Right Actions */}
          <div className="col-6 col-md-3">
            <div className="navbar-actions">
              {/* Desktop Buttons - Hidden on mobile */}
              <button className="login-btn d-none d-md-inline-block"
              onClick={() => Navigate("/login")}
              >
                Login
              </button>
              {/* <MyButton variant="primary" className="d-none d-lg-inline-block">
                Become a Distributor
              </MyButton> */}

              {/* Mobile Menu Button - Only visible on mobile */}
              <button
                className="mobile-menu-btn d-md-none"
                onClick={onMenuClick}
              >
                <CiMenuFries size={24} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MyNavbar;
